import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';

function AddUpdateTempletPopup({
  handleClose,
  handleSaveUpdate,
  templetId,
  name,
}) {
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');

  useEffect(() => {
    if (templetId) {
      (async () => {
        try {
          const response = await post(
            'api/patient/treatmentPlan/mhtpTempletListEdit',
            {
              type: name,
              id: templetId,
            }
          );
          if (response.status === 200) {
            setTitle(response?.data?.templetData?.title);
            setText(response?.data?.templetData?.description);
          }
        } catch (err) {
          setUiMessage('err', err.message);
        }
      })();
    }
  }, [name, templetId]);

  return (
    <div className="modalBackground">
      <div
        className="center-popup"
        style={{
          width: '500px',
          position: 'absolute',
          backgroundColor: '#fff',
          zIndex: '20',
        }}
      >
        <div className="template-add-edit-popup-hdr">
          <span className="head-cmt">
            {templetId ? 'Update' : 'Add '}{' '}
            {name === 'goal'
              ? 'goal'
              : name === 'object'
              ? 'objective'
              : name === 'intervention'
              ? 'Intervention'
              : ''}{' '}
            template:
          </span>
          <span className="cross" onClick={handleClose}>
            X
          </span>
        </div>

        <div className="plan-edit-right">
          <div className="plan-name-row">
            <span className="label">Name</span>
            <span className="value">
              <input
                type="text"
                placeholder="Write template name here..."
                className="datalistInput"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </span>
          </div>
          <textarea
            className="plan-template-textarea"
            placeholder="You can write here..."
            value={text}
            onChange={(e) => setText(e.target.value)}
          ></textarea>
          <div className="plan-button-row">
            <span className="actn-No clear-right center" onClick={handleClose}>
              Cancel
            </span>
            {templetId ? (
              <span
                className="actn-yes center"
                onClick={() => handleSaveUpdate(templetId, title, text)}
              >
                Update
              </span>
            ) : (
              <span
                className="actn-yes center"
                onClick={() => handleSaveUpdate(templetId, title, text)}
              >
                Save
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddUpdateTempletPopup;
